/*
 * Purpose : Tool Add or Edit Page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React,{useState} from "react";
import {  Col,  Row,  Button, FormGroup,  Label,  Input, Alert} from "reactstrap";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup'
import _ from "lodash";
import { useForm, Controller, reset } from "react-hook-form";
import moment from "moment";

//import { API, graphqlOperation } from "aws-amplify";
import LoadingModal from "../../UI/modals/loadingModal";
import {ToolSalesFormService} from '../../../services/ToolSalesFormService';

const formService = new ToolSalesFormService();

const AddEditToolDtls = (props) => {

  //console.log("props.stateVals",props.stateVals)

  // setting the initial values from the received props
  const initialValuesFromProps = {
      id:props.stateVals.id,
      transactionid:props.stateVals.transactionid,
      toolid: props.stateVals.toolid,
      fab:props.stateVals.fab,
      location:props.stateVals.location,
      vendor:props.stateVals.vendor,
      model:props.stateVals.vendor,
      serialnum:props.stateVals.serialnum,
      asset_mgt_status:props.stateVals.asset_mgt_status,
      price:props.stateVals.price?props.stateVals.price:0.0,
      nbv:props.stateVals.nbv?props.stateVals.nbv:0.0,
      org_eqp_price:props.stateVals.org_eqp_price?props.stateVals.org_eqp_price:0.0,
      price_percent:props.stateVals.price_percent?props.stateVals.price_percent:0.0,
      capitalized_date:props.stateVals.capitalized_date?props.stateVals.capitalized_date:moment().format("YYYY-MM-DD"),
      fin_analysis:props.stateVals.fin_analysis?props.stateVals.fin_analysis:"",
      sales_type:props.stateVals.sales_type,
      remarks:props.stateVals.remarks?props.stateVals.remarks:"",
      no_internal_reuse:props.stateVals.no_internal_reuse==="Yes"?true:false,
      // removal_path_clear:props.stateVals.removal_path_clear==="Yes"?true:false,
      // no_trade_in:props.stateVals.no_trade_in==="Yes"?true:false,
      declared_type:props.stateVals.declared_type
  }
  const [toolList, setToolList] = useState(props.toolList);
  const [processing, setProcessing] = useState(false)
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(initialValuesFromProps)
  const [confirmError, setConfirmError] = useState(null)

  // validation schema to validate the mandatory fields of the form                                     
  const schema = Yup.object().shape({
    toolid: Yup.string("value must be a string").required("Tool ID is Required"),
    fab: Yup.string("value must be a string").required("Fab is Required"),
    location: Yup.string("value must be a string").required("Location is Required"),
    vendor: Yup.string("value must be a string").required("Vendor/Supplier is Required"),
    model: Yup.string("value must be a string").required("Model is Required"),
    serialnum: Yup.string("value must be a string").required("Serial Number is Required"),
    price: Yup.number("value must be a number").required("Offer Price is Required").positive(" Offer Price should be a positive value"),
    //nbv: Yup.number("value must be a number").moreThan(-1, 'Enter valid Amount').lessThan(Yup.ref('price'),"NBV value must be less than Price"),
    nbv: Yup.number("value must be a number").moreThan(-1, 'Enter valid Amount'),
    sales_type: Yup.string("value must be a string").required("Sales Type is Required")
  });

  // hooking with react-hook-form
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    getValues
  } = useForm({
    defaultValues:initialValues,
    resolver: yupResolver(schema),
  });
  
  // fun to call on form submit
  const onSubmit = (data,e) => {
    //e.target.reset();
    //alert(JSON.stringify(data));
    setProcessing(true)
    props.submithandler(data)
  };

  // to get tool details like vendor/suplier etc..
  const getToolDetails = async (e) => {
    setLoading(true);
    console.log("declared==>",initialValues.declared_type)
    if(e.target.value==="" || initialValues.declared_type==="No"){
      reset({...initialValues, toolid:e.target.value})
      setLoading(false)
      return false
    }
    const toolDetList = _.filter(toolList, ['toolid', e.target.value])
    console.log("selected tool=>",toolDetList);

    let apiResult;
    try {            
      apiResult = await formService.getToolGeneralData(toolDetList[0].transactionid)
    } catch (error) {
      console.log("error==>",error)
      setConfirmError("There is a technical error. Please try again..!")
      setLoading(false)
      return false
    }

    //Added by Bishnu to get the latest remarks from UEMS table
    let uemsRemarks 
    try {     
      if (toolDetList[0].txnuemseqptid=="NA" || toolDetList[0].txnuemseqptid=="Not available from UEMS")
      {
      // Logic to take toolid if UEMS EQUPID is NA
        function ReverseString(str) {
            return str.split('').reverse().join('')}
          
          let initial = toolDetList[0].toolid;
          
          let trimmed = initial.replace(/\s+/g, '');
          
          let reverseString = ReverseString(trimmed);
          
          let position = reverseString.indexOf("(") + 1;
          
          let result = reverseString.slice(position);
          
          let finalString = ReverseString(result);
          
          console.log("Final String-->",finalString);      
        uemsRemarks = await formService.getUmesRemarks(finalString);
      }     
      else{
        uemsRemarks = await formService.getUmesRemarks(toolDetList[0].txnuemseqptid)
      }  
      
    } catch (error) {
      console.log("error==>",error)
      setConfirmError("There is a technical error in UEMS. Please try again..!")
      setLoading(false)
      return false
    }
    console.log ("UEMS Remarks=",uemsRemarks);
    const mergedList = _.merge(toolDetList,apiResult)[0]
    console.log("mergedList=>",mergedList)

    setInitialValues({...initialValues, toolid:mergedList.toolid, fab:mergedList.txnfab, location:mergedList.location, 
                          vendor:mergedList.vendorsupplier, model:mergedList.model, serialnum:mergedList.serialno,
                          asset_mgt_status:mergedList.txn_assets_mgt_status,remarks:uemsRemarks})
    reset({...initialValues, toolid:mergedList.toolid, fab:mergedList.txnfab, location:mergedList.location, 
              vendor:mergedList.vendorsupplier, model:mergedList.model, serialnum:mergedList.serialno,
              asset_mgt_status:mergedList.txn_assets_mgt_status,remarks:uemsRemarks})
    setLoading(false);
  }  
  
  // common code to generate Input field based on the props
  const InputField = (label, name, required, declaredCheck, readonlyFlag ) => {
    let labelText = required?<>{label}&nbsp;&nbsp;<b style={{ color: "red" }}>*</b></>:label
    return(
            <FormGroup>              
              <label>{labelText}</label>
              <Controller
                render={({ field }) => <Input {...field}
                type={name==="capitalized_date" ? "date" : name==="fin_analysis"?"textarea":"text"}
                invalid={errors[`${name}`]}
                readOnly={ readonlyFlag || (declaredCheck ? (initialValues.declared_type==="Yes"? true:false):false) }
                />}
                declaredCheck
                control={control}
                {...register(`${name}`)}
              />
              {errors[`${name}`] && <p style={{color:"red"}}>{errors[`${name}`].message}</p>}
            </FormGroup>
          )
  }

  // common code to generate check box field based on the props
  const CheckboxField = (label, name) => {
    return (
              <FormGroup check>
                <Controller
                  render={({ field }) => <Input  {...field}
                    checked={getValues(`${name}`)}
                    type="checkbox"
                    invalid={errors[`${name}`]}                    
                    style={{height: "20px",width: "20px"}}
                  />}
                  control={control}
                  {...register(`${name}`)}
                />
                <Label>&nbsp;&nbsp;{label}</Label>
                {/* {errors.no_internal_reuse && <p style={{color:"red"}}>{errors.no_internal_reuse.message}</p>} */}
              </FormGroup>
            )
  }

  // common code to generate dropdown or free text field based on the props
  const SelectField = (label, name, declaredCheck, onChangeEvent) => {
    const salesTypeList = [ <option key="1" value="">---- Select Sales Type ----</option>,
                            <option key="2" value="Credit">Credit</option>,
                            <option key="3" value="Cash">Cash</option>
                          ] 
    const toolidList =  [
                      <option key="0" value="">--- Select Tool ID ---</option>,
                      toolList.map( el => <option key={el.toolid} value={el.toolid}>{el.toolid}</option>)
                    ]                    
    const SubInput = (props) => {
                    return onChangeEvent
                    ?
                    <Input type= {declaredCheck?(initialValues.declared_type==="Yes"?"select":"input"):"select"} {...props}
                      onChange={ (e) => getToolDetails(e) }  
                      invalid={errors[`${name}`]}
                    >
                      {name==="toolid"?toolidList:salesTypeList}
                    </Input>
                    :
                    <Input type= {declaredCheck?(initialValues.declared_type==="Yes"?"select":"input"):"select"} {...props}
                      invalid={errors[`${name}`]}
                    >
                      {name==="toolid"?toolidList:salesTypeList}
                    </Input>
    }
    return (
              <FormGroup>
                <label>{label}&nbsp;&nbsp;<b style={{ color: "red" }}>*</b></label>
                <Controller
                  render={({ field }) => SubInput(field) }
                  control={control}
                  {...register(`${name}`)}
                />
                {errors[`${name}`] && <p style={{color:"red"}}>{errors[`${name}`].message}</p>}
            </FormGroup>
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>      
    
      <LoadingModal open={loading} msg="Loading..." />
      <Alert color="danger" isOpen={confirmError != null ? true : false}>
                {confirmError}
              </Alert>
      <input type="hidden" {...register('id')} />
      <input type="hidden" {...register('declared_type')} />

      <Row form style={{justifyContent:"flex-start"}}>
        <Col sm="auto" md="auto" lg="3">
          {SelectField("Tool ID","toolid",true, true)}          
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Fab","fab",true,true)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Location","location",true,true)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Vendor/Supplier","vendor",true,true)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Model","model",true,true)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Serial Number","serialnum",true,true)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Assets Management Status","asset_mgt_status",false,true)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Remarks","remarks",false,false)}
        </Col>
      </Row>
      
      <Row form style={{justifyContent:"flex-start"}}>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Offer Price* ($US)","price",true, false)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("NBV($US)","nbv",false, false, false)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Original Eqpt Cost ($US)","org_eqp_price",false, true, true)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Offer Price/ Original Eqpt Cost (%)","price_percent",false, true, true)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {InputField("Capitalization Date","capitalized_date",false, false)}
        </Col>
        <Col sm="auto" md="6" lg="6">
          {InputField("Finance Analysis","fin_analysis",false, false)}
        </Col>
        <Col sm="auto" md="auto" lg="3">
          {SelectField("Sales Type","sales_type",false,false)}
        </Col>
      </Row>
      <Row form style={{justifyContent:"flex-start"}}>        
        
        <Col md="auto" >
          {/* {CheckboxField("AO confirm no Internal Reuse/Part Use","no_internal_reuse")} */}
          {CheckboxField("AO confirm no Internal Reuse/Part Use/ Trade-In","no_internal_reuse")}          
        </Col>
        {/* <Col md="auto">
          {CheckboxField("AO confirm removal path clear/ site budget","removal_path_clear")}
        </Col>
        <Col md="auto">
          {CheckboxField("GSM confirm no Trade-In","no_trade_in")}
        </Col> */}
      </Row>

      {/* <Row  style={{justifyContent:"flex-start"}}>
        <Col md="auto" > */}
          {/* {CheckboxField("AO confirm no Internal Reuse/Part Use","no_internal_reuse")} */}
          {/* {CheckboxField("AO confirm no Internal Reuse/Part Use/ Trade-In","no_internal_reuse")}          
        </Col> */}
        {/* <Col md="auto">
          {CheckboxField("AO confirm removal path clear/ site budget","removal_path_clear")}
        </Col>
        <Col md="auto">
          {CheckboxField("GSM confirm no Trade-In","no_trade_in")}
        </Col> */}
      {/* </Row> */}

      <FormGroup style={{textAlign: "center", marginTop:"1rem"}}>
          <Row>
            <Col>
              <Button color="primary" className={"userFormBtn"} style={{backgroundColor:"#fb8734"}}
                      type="submit"
                      disabled={processing}>
                      { processing && <span><i className="fa fa-spinner fa-spin"></i>  Processing... </span> }
                      { !processing && <span>Submit</span> }
              </Button>
            </Col>
            <Col>
              <Button color="secondary" className={"userFormBtn"} value="" onClick={props.closeHandler}>Close</Button>
            </Col>
          </Row>
      </FormGroup>

    </form>
  );
};
export default AddEditToolDtls;